import React from "react";
import SuperAdminHeader from "../../components/superAdminCompoents/SuperAdminHeader";
import SuperAdminSidebar from "../../components/superAdminCompoents/SuperAdminSidebar";
import AdminTittle from "../../components/adminComponents/AdminTittle";
import SAdminSendMsgToAdmin from "../../components/superAdminCompoents/superAdminMessageCompoents/SAdminSendMsgToAdmin";
const SuperAdminComposetoAdminPage = () => {
  return (
    <>
      {/* <SuperAdminHeader />
            <SuperAdminSidebar /> */}
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* <AdminTittle title="To All Companies Admin" /> */}
            <SAdminSendMsgToAdmin />
          </div>
        </div>
      </div>
    </>
  );
};
export default SuperAdminComposetoAdminPage;
